import React from 'react';
import PropTypes from 'prop-types';
import { HeaderTitle } from './Header.styles.js';
import  { ReactHtmlParser } from 'helpers/utilities.js';

const Header = ({ header, align }) => {
  return <HeaderTitle align={align}>{ReactHtmlParser(header)}</HeaderTitle>;
};

Header.propTypes = {
  title: PropTypes.string,
  header: PropTypes.string,
  align: PropTypes.string
};

export default Header;
